export const userTypes = {
    AUTHENTICATION: 'authentication',
    LOGIN_OR_SIGNUP: 'loginOrSignup',
    LOGOUT: 'logout',
    SET_PLANYO_USER_ID: 'setPlanyoUserId',
    SET_CDC_ID: 'setCdcId',
    SET_USER_ID: 'setUserId',
    SET_USER_SESSION_ID: 'setUserSessionId',
    INACTIVE_DURATION: 24 * 60 * 1000 // 24 minutes
};
